// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3M5w5","messages":"Chat_messages__2uu0o","dateDivider":"Chat_dateDivider__1_eXd"};